import '../Style/BtnC.css'
function BtnCoustom() {
    return (
        <div className="btn-coutom text-center ps-4 col-lg-3 col-sm-4 p-3 fw-bold shadow">
            Get Start
        </div>
    )
}
export default BtnCoustom;